import { render, staticRenderFns } from "./recruit-title.vue?vue&type=template&id=2019ac29&scoped=true&"
import script from "./recruit-title.vue?vue&type=script&lang=js&"
export * from "./recruit-title.vue?vue&type=script&lang=js&"
import style0 from "./recruit-title.vue?vue&type=style&index=0&id=2019ac29&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2019ac29",
  null
  
)

export default component.exports